import axios from 'axios';
import { persistUser, getUserData } from '../store/persistStore';
//when the token has expired the refresh-token can fetch new token
// as given below

export const getRefreshToken = async (refresh_token) => {
  var qs = require('qs');
  const data = {
    grant_type: process.env.REACT_APP_GRANT_TYPE,
    client_id: process.env.REACT_APP_CLIENT_ID,
    client_secret: process.env.REACT_APP_CLIENT_SECRET,
    refresh_token: refresh_token,
  };
  const response = await axios.post(
    process.env.REACT_APP_TOKEN_URL,
    qs.stringify(data)
  );
  if (response.data) {
    const userData = getUserData();
    const token = response.data.access_token;
    const refreshToken = response.data.refresh_token;
    const updatedUserData = { ...userData, token, refresh_token: refreshToken };
    persistUser(updatedUserData);
    return token;
  }
};
